export default {
    computed: {
        imgPrefix() {
            return "";
        },
        token(){
            return this.cookie.get('token');
        }
    },
    methods: {
        messageBox(res){
            this.$message({
              message:res.msg,
              type:res.code == 200 ? "success" : "error"
            })
          }
    },
}

// canvas导入
import konva from './canvas/KONVA'

export { konva }